const footerLinks = {
  'VergeIO Çözümleri': [
    { label: 'En iyi Sanallaştırma Alternatifi', href: '/vmware-alternative' },
    { label: 'SAN Değişimi', href: '/san-replacement' },
    { label: 'Altyapı Modernizasyonu', href: '/infrastructure-modernization' },
    { label: 'Yapay Zeka (VergeIQ)', href: '/vergeiq' },
    { label: 'Hyperconverged (HCI)', href: '/hci' },
    { label: 'Güvenli Araştırma Bilişimi', href: '/secure-research-computing' },
  ],
  'Özellikler': [
    { label: 'Sanal Veri Merkezleri', href: '/virtual-data-centers' },
    { label: 'Yüksek Erişilebilirlik', href: '/high-availability' },
    { label: 'ioClone', href: '/ioclone' },
    { label: 'ioReplicate', href: '/ioreplicate' },
    { label: 'ioFortify', href: '/iofortify' },
    { label: 'ioMigrate', href: '/iomigrate' },
    { label: 'ioProtect', href: '/ioprotect' },
    { label: 'ioOptimize', href: '/iooptimize' },
    { label: 'ioGuardian', href: '/ioguardian' },
  ],
  'Ürün': [
    { label: 'Avantajlar', href: 'https://www.verge.io/benefits/' },
    { label: 'Mimari Genel Bakış', href: '/architecture' },
    { label: 'Kullanım Senaryoları', href: 'https://www.verge.io/use-cases/' },
  ],
  'Blog': [
    { label: '2026\'da Depolama Yenileme Maliyeti', href: '/blog/storage-yenileme-maliyeti-2026' },
    { label: 'Hipervizör RAM Tüketimini Azaltma', href: '/blog/ram-tuketimi-azaltma' },
    { label: 'VM Yoğunluğunun Gizli Riski', href: '/blog/vm-yogunluk-patlama-yaricapi' },
    { label: 'Felaket Kurtarmadan ROI Elde Etmek', href: '/blog/felaket-kurtarma-roi' },
    { label: 'En Kolay VM Alternatifi', href: '/blog/kolay-vmware-alternatifi' },
    { label: 'Alternatiflerde: Gözden Kaçırılanlar', href: '/blog/vmware-alternatifleri-kriterler' },
    { label: 'VM\'den Özel Buluta Geçiş', href: '/blog/vmwareden-ozel-buluta' },
    { label: 'Özel Bulut OS Nedir?', href: '/blog/ozel-bulut-os-nedir' },
    { label: 'VxRail Alternatifleri', href: '/blog/vxrail-alternatifleri' },
    { label: 'Alternatiften Çıkış', href: '/blog/yerinde-vmware-cikisi' },
    { label: 'Tüm Yazılar →', href: '/blog' },
  ],
};

export default function FooterSection() {
  return (
    <footer className="bg-[#f1f5f9] border-t border-gray-200 pt-12 pb-8 px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-8 mb-10">
          {/* Marka sütunu */}
          <div className="col-span-2 lg:col-span-1">
            <div className="flex items-center gap-1 mb-4">
              <span className="text-xl font-bold text-[#1a1a2e]">verge</span>
              <span className="text-xl font-bold text-[#e8600a]">.tr</span>
            </div>
          </div>

          {/* Link sütunları */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section} className="col-span-1">
              <h3 className="text-xs font-bold text-[#1a1a2e] uppercase tracking-wider mb-4">{section}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-xs text-[#64748b] hover:text-[#e8600a] transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-200 pt-6 text-center">
          <p className="text-xs text-[#94a3b8]">© 2026 VergeTR. Tüm Hakları Saklıdır.</p>
        </div>
      </div>
    </footer>
  );
}
